module.exports = __webpack_public_path__ + "media/images/country_flags/td-d63fcd08b1cd66c0c6ba2c21db49d53e.png";